import { createCachedGet } from '../core/request';
import { EndpointByMethod } from '../__generated__/access/validators';
import { getApiClient } from './client';
import { getCache } from './cache';
import type { CachedFunction } from '@solidjs/router';
import type { FetchResponse, FetchOptions } from 'openapi-fetch';
import type { FilterKeys, PathsWithMethod } from 'openapi-typescript-helpers';
import type { paths } from '../__generated__/access/database';
import type { GetOptions } from '../core/request';

export type { GetOptions } from '../core/request';

const runtimeCachedGet = createCachedGet({
	endpointByMethod: EndpointByMethod,
	getApiClient,
	getCache,
});

export function cachedGet<
	Path extends PathsWithMethod<paths, 'get'>,
	Res extends NonNullable<
		FetchResponse<
			'get' extends infer T
				? T extends 'get'
					? T extends keyof paths[Path]
						? paths[Path][T]
						: Record<string, string>
					: never
				: never,
			'json',
			'application/json'
		>['data']
	>,
>(
	path: Path,
	rest?: Omit<FetchOptions<FilterKeys<paths[Path], 'get'>>, 'params'>,
	opts?: GetOptions,
	key?: string,
): CachedFunction<(params: FetchOptions<FilterKeys<paths[Path], 'get'>>['params']) => Promise<Res>> {
	return runtimeCachedGet(path as string, rest as Record<string, unknown> | undefined, opts, key) as CachedFunction<
		(params: FetchOptions<FilterKeys<paths[Path], 'get'>>['params']) => Promise<Res>
	>;
}
